import { User } from './user';

export class SchemeGroup {
  scheme_group_number!: string;
  scheme_group_name!: string;
  scheme_group_description!: string;
  status!: string;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  constructor(data: any) {
    this.scheme_group_number = data.scheme_group_number;
    this.scheme_group_name = data.scheme_group_name;
    this.scheme_group_description = data.scheme_group_description;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
